exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.draggable .ivu-form-item-content {\n  margin-bottom: 8px;\n}\n", "", {"version":3,"sources":["D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/view/D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/view/view-form-draggable.vue"],"names":[],"mappings":";AA60BA;EACA,mBAAA;CACA","file":"view-form-draggable.vue?vue&type=style&index=0&id=0918a6d0&prod&lang=css&","sourcesContent":["\n.draggable .ivu-form-item-content {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);

// exports
